'use client';
import React, { useState, useRef } from 'react';
import { AxiosInstance } from '../utils';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import validator from 'validator';
import { InputComponent, DropDownComponent } from '../custcomponents';

import { ToastContainer, toast } from 'react-toastify';

function validate(fieldName, fieldValue, validatType, canNull) {
    let isvalid = true;
    if (!canNull) {
        if (fieldValue == null || fieldValue == '') {
            toast.error(`${fieldName} cannot be Blank.`);
            return false;
        }
    }
    switch (validatType) {
        case 'email':
            if (!validator.isLength(fieldValue, { min: 0, max: 70 })) {
                toast.error(`Invalid Email. Field: ${fieldName}.`);
                isvalid = false;
            }
            break;
        case 'name':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'phonenumber':
            if (fieldValue != null && !validator.isLength(fieldValue, { min: 0, max: 15 })) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`)
                isvalid = false;
            }
            break;
        case 'url':
            if (!validator.isLength(fieldValue, { min: 0, max: 100 })) {
                toast.error(`Invalid url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'linkedinurl':
            if (fieldValue != null && !validator.isLength(fieldValue, { min: 0, max: 256 })) {
                toast.error(`Invalid linkedin Url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'title':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
        case 'groupType':
            if (!validator.isLength(fieldValue, { min: 0, max: 60 })) {
                toast.error(`Invalid Data. Field: ${fieldName}, field value ${fieldValue}`);
                isvalid = false;
            }
            break;
    }

    switch (validatType) {
        case 'email':
            if (!validator.matches(fieldValue, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                toast.error(`Invalid Email. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'officeemail':
            if (fieldValue != null && !validator.isEmpty(fieldValue) && !validator.matches(fieldValue, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                toast.error(`Invalid Email. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'name':
            if (!validator.isAlphanumeric(fieldValue, 'en-US', { ignore: ' .-\'' })) {
                toast.error(`Invalid Data. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'phonenumber':
            if (!validator.matches(fieldValue, /^[0-9]{10}$/)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'url':
            if (!validator.isURL(fieldValue)) {
                toast.error(`Invalid mobile number. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'linkedinurl':
            if (fieldValue != null && !validator.isEmpty(fieldValue) && (!validator.isURL(fieldValue) || !validator.contains(fieldValue, 'linkedin.com', { ignoreCase: true }))) {
                toast.error(`Invalid linkedin Url. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
        case 'groupType':
            if (!validator.matches(fieldValue, 'BSides Bangalore|W3-CS')) {
                toast.error(`Invalid Group. Field: ${fieldName}`);
                isvalid = false;
            }
            break;
    }

    return isvalid;
}

export const MemberRegistration = ({ }) => {
    const [groupType, setGroupType] = useState('Group Type');
    const [declarationChecked, setDeclarationChecked] = useState(false);
    const [termsChecked, setTermsChecked] = useState(false);
    const formRef = useRef(null as any);
    const [submitLoading, setSubmitLoading] = useState(false);

    const onformMemberSubmit = async (event: any) => {
        event.preventDefault();
        setSubmitLoading(true);
        const formData = new FormData(event.currentTarget);
        const memberName = formData.get("MemberName");
        const memberTitle = formData.get("MemberTitle");
        const memberCompany = formData.get("MemberCompany");
        const memberLocation = formData.get("MemberLocation");
        const memberPhoneNumber = formData.get("MemberPhoneNumber");
        const memberPersonalMailId = formData.get("MemberPersonalMailId");
        const memberOfficeMailId = formData.get("MemberOfficeMailId");
        const memberLinkedInUrl = formData.get("MemberLinkedInUrl");
        const memberGroupType = formData.get("MemberGroupType");

        if (!validate('Name', memberName, 'name', false) || !validate('Title', memberTitle, 'title', false) || !validate('Company', memberCompany, 'name', false) ||
            !validate('Location', memberLocation, 'name', false) || !validate('Phone Number', memberPhoneNumber, 'phonenumber', false) ||
            !validate('Personal Email', memberPersonalMailId, 'email', false) || !validate('Office Email', memberOfficeMailId, 'officeemail', true) ||
            !validate('LinkedIn URL', memberLinkedInUrl, 'linkedinurl', true) || !validate('Group Type', memberGroupType, 'groupType', false)) {
            setSubmitLoading(false);
            return;
        }

        let requestReq = {
            'name': memberName,
            'title': memberTitle,
            'company': memberCompany,
            'location': memberLocation,
            'phonenumber': memberPhoneNumber,
            'personalmailid': memberPersonalMailId,
            'officemailid': memberOfficeMailId,
            'linkedinurl': memberLinkedInUrl,
            'groupType': memberGroupType,
            'status': 'NOT_VERIFIED'
        };
        const { data: response } = await AxiosInstance.post('/api/memberregistration', requestReq, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.result == "Success") {
            toast(`Member registered successfully.`, { autoClose: 5000 });
            if (formRef && formRef.current) {
                formRef.current.reset();
                setGroupType('Group Type');
                setDeclarationChecked(false);
                setTermsChecked(false);
            }
        }
        else {
            toast.error(response.msg ? response.msg : "Failed to Register Member");
        }
        setSubmitLoading(false);
    }

    return (
        <>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <form ref={formRef} onSubmit={onformMemberSubmit}>
                        <InputComponent custname="MemberName" custid="txtmembername" custplaceholder="Name" />
                        <InputComponent custname="MemberTitle" custid="txtmembertitle" custplaceholder="Title" />
                        <InputComponent custname="MemberCompany" custid="txtmembercompany" custplaceholder="Company" />
                        <InputComponent custname="MemberLocation" custid="txtmemberlocation" custplaceholder="Location" />
                        <InputComponent custname="MemberPhoneNumber" custid="txtmemberphonenumber" custplaceholder="Phone Number" />
                        <InputComponent custname="MemberPersonalMailId" custid="txtmemberpersonalmailid" custplaceholder="Personal Email" />
                        <InputComponent custname="MemberOfficeMailId" custid="txtmemberofficemailid" custplaceholder="Office Email" />
                        <InputComponent custname="MemberLinkedInUrl" custid="txtmemberlinkedinurl" custplaceholder="LinkedIn URL" />
                        <DropDownComponent names={["BSides Bangalore", "W3-CS"]} custname="MemberGroupType" custid="txtmembergrouptype" custplaceholder="Group Type" externalstateValue={groupType} onExternalValue={setGroupType} />

                        
                            <input
                                type="checkbox"
                                id="declarationCheck"
                                checked={declarationChecked}
                                onChange={(e) => setDeclarationChecked(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="declarationCheck">
                                I hereby declare that the above information is true & correct to the best of my knowledge and belief. In case of false information, suppression or concealment, BSides Bangalore will not be responsible for any sort of consequences. The information provider will be accountable for legal, financial or any other consequences.
                            </label>
                      

                       
                            <input
                                type="checkbox"
                                id="termsCheck"
                                checked={termsChecked}
                                onChange={(e) => setTermsChecked(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="termsCheck">
                                I agree to the <a href="https://bsidesbangalore.in/privacypolicy?policy_type=Terms" target="_blank">Terms and Conditions</a> and <a href="https://bsidesbangalore.in/privacypolicy" target="_blank">Privacy Policy</a>.
                            </label>
                        

                        <div className="form-field text-center mgt-40 wow fadeInUp" data-wow-duration="300ms">
                            <button type="submit" disabled={submitLoading || !declarationChecked || !termsChecked} className="btn-default">REGISTER MEMBER {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                        </div>
                    </form>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <h4 className="warningmg">Important Notes</h4>
                    <p  style={{ listStyleType: 'disc', color: '#000', paddingLeft: '20px' }}>
                        The registration fees for both the conference and training sessions are required to be paid. Both members and non-members are required to pay for the service, as it is not free for anyone.
                    </p>
<br></br>
                    <h4 className="warningmg">Expectations</h4>
                    <ul style={{ listStyleType: 'disc', color: '#000', paddingLeft: '20px' }}>
                        <li>Spread word about our chapter related events through your social media handles</li>
                        <li>Contribute positively to our chapter in all possible ways.</li>
                    </ul>
<br></br>
                    <h4 className="warningmg">Benefits</h4>
                    <ul style={{ listStyleType: 'disc', color: '#000', paddingLeft: '20px' }}>
                        <li>Special discounts for training sessions conducted by the chapter.</li>
                        <li>Receive discounts on conference fee</li>
                        <li>Network with other professionals by participating in chapter managed events.</li>
                        <li>Opportunities to become SME and contribute to our future events like academia outreach, webinars, research, blogs etc</li>
                        <li>Opportunities for Volunteering</li>
                        <li>CPE certificate based on your contribution to the chapter</li>
                    </ul>
                </div>
            </div>
        </>);
}

function MemberRegistrationSection({ }) {
    return (<section id="memberregister" className="register-sec sec-padding" data-scroll-index="8">
        <div className="container">
            <div className="sec-title">
                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                <h3 className="wow fadeInRight" data-wow-duration="500ms">Register as Member <small>/ Become a Member!</small></h3>
            </div> {/* <!--sec-title end--> */}
            <div className="register-sec-details">
                <MemberRegistration />
                <div className="row pt-4">
                    <div className="col-lg-12 col-md-6 col-sm-6">
                        <ul>
                            <li className="warningmg"><i className="fa fa-circle" /> By registering, you are expressly consenting to our <a href="https://bsidesbangalore.in/privacypolicy?policy_type=Terms" target="_blank">Terms and Conditions</a>, which we reserve the right to modify periodically.</li>
                        </ul>
                    </div>
                </div>
            </div> {/* <!--register-sec-details end--> */}
        </div>
    </section>);
};
export default MemberRegistrationSection;